import { render, staticRenderFns } from "./myUser.vue?vue&type=template&id=5bbb19a6&scoped=true&"
import script from "./myUser.vue?vue&type=script&lang=js&"
export * from "./myUser.vue?vue&type=script&lang=js&"
import style0 from "./myUser.vue?vue&type=style&index=0&id=5bbb19a6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbb19a6",
  null
  
)

export default component.exports